import { request } from '../utils/axios-utils';
import axios from 'axios';

export const getImageUrlPreset = async filename => {
    try {
        const response = await request({
            // url: `/anglePreset/editingGuidelines/presignedUrl`,
            url: `/anglePreset/guidelines/presignedUrl`,
            method: 'GET',
            params: { filename },
        });
        return response.data;
    } catch (err) {
        throw err;
    }
};

export const createPreset = async data => {
    try {
        const response = await request({
            // url: `/anglePreset/editingGuidelines/`,
            url: `/anglePreset/guidelines/`,
            method: 'POST',
            data: data,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const putImageToS3 = async (url, file, onProgressCallBack) => {
    try {
        const response = await axios.put(url, file, {
            headers: {
                'Content-Type': file.type,
            },
            onUploadProgress: progressEvent => {
                const { loaded, total } = progressEvent;
                let percent = Math.floor((loaded * 99) / total);
                onProgressCallBack(percent);
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
